import Loader from './MainLoader';

export default Loader;